import React, { Component } from "react";
import { message, Table, Tag, Spin, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import axios from "axios";
import { ModalItem, ButtonItem } from "../../../../Components/Items";

const prioridadColors = ["default", "cyan", "green", "gold", "orange", "red"];

class ModalPlantillaProceso extends Component {
  state = {
    loading: false,
    plantillas: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarPlantillas();
    }
    if (!this.props.visible && prevProps.visible) {
      this.setState({ plantillas: [], loading: false });
    }
  }

  consultarPlantillas() {
    this.setState({ loading: true });
    axios
      .post(
        "proceso/obtenerPlantillasProceso", 
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const data = res.data.data;
          const lista = Array.isArray(data) ? data : data?.procesos || [];
          this.setState({ plantillas: lista.map((p, i) => ({ ...p, _rowKey: p._id || `proc_${i}` })) });
        } else {
          this.setState({ plantillas: [] });
        }
      })
      .catch(() => message.error("Error al cargar plantillas de procesos"))
      .finally(() => this.setState({ loading: false }));
  }

  render() {
    const { visible, onCancel, onUsar } = this.props;
    const { loading, plantillas } = this.state;

    const columnas = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        ellipsis: true,
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        ellipsis: true,
      },
      {
        title: "Versión",
        key: "version",
        align: "center",
        width: 90,
        render: (_, r) => (
          <Tag color="purple">{r.version || "-"}</Tag>
        ),
      },
      {
        title: "Puntos",
        key: "puntos",
        align: "center",
        width: 80,
        render: (_, r) => (
          <Tag color="blue">{r.puntos?.length ?? 0}</Tag>
        ),
      },
      {
        title: "Prioridad",
        key: "prioridad",
        align: "center",
        width: 90,
        render: (_, r) => (
          <Tag color={prioridadColors[r.prioridad] || "default"}>
            Nivel {r.prioridad ?? 0}
          </Tag>
        ),
      },
      {
        title: "Acción",
        key: "usar",
        width: 90,
        render: (_, record) => (
          <Tooltip title="Usar esta plantilla">
            <ButtonItem
              size="small"
              type="primary"
              onClick={() => onUsar(record)}
              icon={<PlusOutlined />}
            />
          </Tooltip>
        ),
      },
    ];

    return (
      <ModalItem
        title="Seleccionar Plantilla de Proceso"
        visible={visible}
        spinning={false}
        onCancel={onCancel}
        paddingTop
        width={900}
      >
        <div style={{ marginTop: 16 }}>
          <Spin spinning={loading}>
            {!loading && plantillas.length === 0 && (
              <p style={{ textAlign: "center", color: "#999", padding: "24px 0" }}>
                No hay procesos de plantilla disponibles en la base de datos.
              </p>
            )}
            <Table
              dataSource={plantillas}
              columns={columnas}
              rowKey="_rowKey"
              size="small"
              pagination={{ pageSize: 8 }}
            />
          </Spin>
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalPlantillaProceso);